module.exports = {
    "collapse": `\u{6298}\u{53E0}`,
    "expand": `\u{6269}\u{5C55}`
};


//# sourceMappingURL=zh-CN.main.js.map
